// extracted by mini-css-extract-plugin
module.exports = {"dock":"ToolDock_dock__5rV7o","tool":"ToolDock_tool__5krOe","hint":"ToolDock_hint__2ED4D","hintMobile":"ToolDock_hintMobile__2Ae3n","hintDesktop":"ToolDock_hintDesktop__Iq8_m"};